export const saveToken = (token) => {
	localStorage.setItem('&0k3($~7', token);
}

export const getToken = () => {
	return localStorage.getItem('&0k3($~7');
}

export const removeToken = () => {
	localStorage.removeItem('&0k3($~7');
}

export const isLoggedIn = () => {
	return Boolean(localStorage.getItem('&0k3($~7'));
}

export const saveId = (token) => {
	localStorage.setItem('uid', token);
}

export const getId = () => {
	return localStorage.getItem('uid');
}

export const removeId = () => {
	localStorage.removeItem('uid');
}